import { render } from "./Pinonly.vue?vue&type=template&id=130b4bc1"
import script from "./Pinonly.vue?vue&type=script&lang=js"
export * from "./Pinonly.vue?vue&type=script&lang=js"

import "./Pinonly.vue?vue&type=style&index=0&id=130b4bc1&lang=css"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__